import React from "react";

function Footer() {
	return <footer className="flex justify-center">
		© 2023 Inqutec Labs. All rights reserved.
	</footer>;
}

export default Footer;